var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
  name: 'LegoCardProcess',
  params: { process: 'Chat', cardId: _vm.card.id },
}}},[_c('LegoBtn',{staticClass:"has-unread-messages"},[_c('span',[_c('i',{staticClass:"far fa-comments"})]),_vm._v(" Chat "),(_vm.hasUnreadMessages)?_c('span',{staticClass:"notification-dot"}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }